import { jsx as _jsx } from "react/jsx-runtime";
import { OAuthButton } from '../oauth/OAuthButton';
import { OAuthProviders } from '../oauth/OAuthProviders';
import { useMicrosoft } from './useMicrosoft';
export const MicrosoftButton = () => {
  const {
    onClick
  } = useMicrosoft();
  return /*#__PURE__*/_jsx(OAuthButton, {
    oauth: OAuthProviders.Microsoft,
    onClick: onClick
  });
};